import { MouseEventHandler, useRef } from 'react';
import { useLongPress as useLongPressHook } from 'react-use';

export const useLongPress = (
  callback: (e: TouchEvent | MouseEvent) => void,
  options?: { isPreventDefault?: boolean; delay?: number; threshold?: number },
): {
  // NOTE: Types needs to much to react-use hook
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly onMouseDown: (e: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  readonly onTouchStart: (e: any) => void;
  readonly onMouseUp: () => void;
  readonly onMouseLeave: () => void;
  readonly onTouchEnd: () => void;
} => {
  const threshold = options?.threshold || 10;
  const startPoint = useRef<{ x: number; y: number }>({ x: 0, y: 0 });
  const shouldExecCallback = useRef<boolean>(true);

  const customCallback = (e: TouchEvent | MouseEvent) => shouldExecCallback.current && callback(e);

  const {
    onMouseDown: orgMouseDown,
    onTouchStart: orgTouchStart,
    onMouseUp: orgMouseUp,
    onMouseLeave: orgMouseLeave,
    onTouchEnd: orgTouchEnd,
  } = useLongPressHook(customCallback, options);

  const onMouseDown: MouseEventHandler = (ev) => {
    startPoint.current.x = ev.pageX;
    startPoint.current.y = ev.pageY;
    orgMouseDown(ev);
  };

  const onTouchStart: MouseEventHandler = (ev) => {
    startPoint.current.x = ev.pageX;
    startPoint.current.y = ev.pageY;
    orgTouchStart(ev);
  };

  const onMouseUp: MouseEventHandler = (ev) => {
    shouldExecCallback.current =
      Math.abs(ev.pageX - startPoint.current.x) <= threshold ||
      Math.abs((ev.pageY = startPoint.current.y)) <= threshold;
    startPoint.current.x = 0;
    startPoint.current.y = 0;
    orgMouseUp();
  };

  const onMouseLeave: MouseEventHandler = (ev) => {
    shouldExecCallback.current =
      Math.abs(ev.pageX - startPoint.current.x) <= threshold ||
      Math.abs((ev.pageY = startPoint.current.y)) <= threshold;
    startPoint.current.x = 0;
    startPoint.current.y = 0;
    orgMouseLeave();
  };

  const onTouchEnd: MouseEventHandler = (ev) => {
    shouldExecCallback.current =
      Math.abs(ev.pageX - startPoint.current.x) <= threshold ||
      Math.abs((ev.pageY = startPoint.current.y)) <= threshold;
    startPoint.current.x = 0;
    startPoint.current.y = 0;
    orgTouchEnd();
  };

  return {
    onMouseDown,
    onTouchStart,
    onMouseUp: onMouseUp as () => void,
    onMouseLeave: onMouseLeave as () => void,
    onTouchEnd: onTouchEnd as () => void,
  };
};
